import { useDeviceType } from "@dash/mq";
import { QuerySkeleton } from "@dash/skeleton";
import { MdOutlineHub } from "react-icons/md";

import { ContactList } from "./ContactList";
import { CustomerQuery } from "./CustomerPage";
import { CustomerSupportTicketsList } from "./CustomerSupportTicketsList";
import { InvitedCustomers } from "./InvitedCustomers";
import { RelatedCustomersList } from "./RelatedCustomersList";
import { RelationList } from "./RelationList";
import { TabHeader } from "./TabHeader";

type Props = {
  customerQuery: CustomerQuery;
};

export const CustomerRelations: React.FC<Props> = ({ customerQuery }) => {
  const { isMobile } = useDeviceType();
  const getDefaultReporterName = (customer: {
    name: string;
    firstName: string;
    lastName: string;
    email: string | null;
  }) => {
    if (customer.name.trim()) return customer.name.trim();
    const joinedName = `${customer.firstName} ${customer.lastName}`.trim();
    if (joinedName) return joinedName;
    if (customer.email) return customer.email.split("@")[0];
    return "";
  };

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      {!isMobile && <TabHeader icon={<MdOutlineHub size={18} />} text="Relacje" />}

      <QuerySkeleton height="41px" query={customerQuery}>
        {(customer) => <RelationList customerUuid={customer.uuid} customerCategories={customer.categories} />}
      </QuerySkeleton>
      <QuerySkeleton height="41px" query={customerQuery}>
        {(customer) => <RelatedCustomersList customerUuid={customer.uuid} />}
      </QuerySkeleton>
      <QuerySkeleton height="41px" query={customerQuery}>
        {(customer) =>
          customer.categories.some((category) => ["pos", "payer", "distributor", "chain"].includes(category)) ? (
            <ContactList customerUuid={customer.uuid} />
          ) : null
        }
      </QuerySkeleton>
      <QuerySkeleton height="41px" query={customerQuery}>
        {(customer) => (
          <CustomerSupportTicketsList
            customerUuid={customer.uuid}
            defaultReporterEmail={customer.email ?? ""}
            defaultReporterName={getDefaultReporterName(customer)}
          />
        )}
      </QuerySkeleton>
    </div>
  );
};
